<template>
  <div>
    <list listTitle="Produtos" :listLogo="module.logo" filterTitle="Listagem de produtos" :loading="loading" :total="productsMarketplaceTotal" :sortFields="sortFields" :sortDefault="{ field: sortFields[0], order: 'desc' }" @change="onChange" @clearFilters="clearFilters">
      <template slot="filters">
        <form-group label="Código do produto">
          <vue-tags-input
            class="form-input"
            v-model="options.code"
            :tags="productCodes"
            :separators="[',']"
            :add-on-key="[',']"
            placeholder=""
            @tags-changed="newCodes => productCodes = newCodes"/>

          <small class="form-help">Utilize vírgula (,) para múltiplos códigos.</small>
        </form-group>

        <form-group label="EAN do produto">
          <input class="form-input" v-model="options.ean">
        </form-group>
        <form-group label="Título do produto">
          <input class="form-input" v-model="options.title">
        </form-group>
        <form-group label="Conta" v-if="moduleIdentifier === 'tikTokShop'">
          <select v-model="options.account" class="form-select">
            <option value=null>Todas</option>
            <option v-for="account in productAccounts" :key="account" :value="account.identifier">{{ account.nickname }}</option>
          </select>
        </form-group>
        <form-group label="Conta" v-if="moduleIdentifier === 'shein'">
          <select v-model="options.account" class="form-select">
            <option value=null>Todas</option>
            <option v-for="account in productAccounts" :key="account" :value="account.identifier">{{ account.nickname }}</option>
          </select>
        </form-group>
        <form-group label="Marca">
          <multiselect
            v-model="options.brand"
            :options="brands"
            selectLabel=""
            selectedLabel=""
            placeholder="Todas"
          />
        </form-group>
        <form-group label="Status do produto">
          <select v-model="options.status" class="form-select">
            <option :value=null>Todos</option>
            <option v-for="status in productStatuses" :key="status" :value="status">
              {{ $te(`${moduleIdentifier}.status.${status}.label`) ? $t(`${moduleIdentifier}.status.${status}.label`) : $t(`${status}.label`) }}
            </option>
          </select>
        </form-group>
        <form-group label="Status do preço do produto">
          <select v-model="options.priceStatus" class="form-select">
            <option :value=null>Todos</option>
            <option v-for="status in productPriceStatuses" :key="status" :value="status">{{ $t(status).label }}</option>
          </select>
        </form-group>
        <form-group label="Status do estoque do produto">
          <select v-model="options.stockStatus" class="form-select">
            <option :value=null>Todos</option>
            <option v-for="status in productStockStatuses" :key="status" :value="status">{{ $t(status).label }}</option>
          </select>
        </form-group>
        <form-group label="Status do envio da imagem" v-if="moduleIdentifier === 'amazon'">
          <select v-model="options.imageStatus" class="form-select">
            <option :value=null>Todos</option>
            <option v-for="status in productImageStatuses" :key="status" :value="status">{{ $t(status).label }}</option>
          </select>
        </form-group>
        <form-group label="Conta" v-if="moduleIdentifier === 'shopee'">
          <select v-model="options.account" class="form-select">
            <option value=null>Todas</option>
            <option v-for="account in productAccounts" :key="account" :value="account.shopId">{{ account.shopName }}</option>
          </select>
        </form-group>
        <form-group label="Tipo de preço">
          <select v-model="options.priceType" class="form-select">
            <option :value=null>Todos</option>
            <option v-for="priceType in productPriceTypes" :key="priceType" :value="priceType">{{ $t(`${priceType}.label`) }}</option>
          </select>
        </form-group>
        <form-group :label="$t(`saleAvailability.label`)">
          <select v-model="options.saleAvailability" class="form-select">
            <option :value=null>Todos</option>
            <option v-for="saleAvailability in productSaleAvailabilities" :key="saleAvailability" :value="saleAvailability">{{ $t(`saleAvailability.${saleAvailability}.label`) }}</option>
          </select>
        </form-group>
        <form-group :label="$t('productGroupedId.label')">
          <input class="form-input" v-model="options.productId">
        </form-group>
        <slot name="custom-filters"/>
      </template>
      <div class="l-col-12@md" v-for="(item, index) in productsMarketplaceItems" :key="index">
        <component :is="productCardComponent" ref="items" :product="item" :module="{ type: 'marketplace', identifier: moduleIdentifier }"/>
      </div>
      <div class="l-col u-textCenter" v-if="!productsMarketplaceItems.length">
        <panel>
          Nenhum produto encontrado.
        </panel>
      </div>
    </list>
  </div>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex'
  import { mapFields } from 'vuex-map-fields'
  import { upperFirst, merge } from 'lodash'
  import FormGroup from '@/components/template/FormGroup'
  import List from '@/components/shared/list/Paginator'
  import api from '@/api'
  import Panel from '@/components/template/Panel'
  import Multiselect from 'vue-multiselect'
  import VueTagsInput from '@johmun/vue-tags-input'

  import ProductCardCarrefour from '@/components/marketplace/carrefour/ProductCard'
  import ProductCardCnova from '@/components/marketplace/cnova/ProductCard'
  import ProductCardColombo from '@/components/marketplace/colombo/ProductCard'
  import ProductCardGfg from '@/components/marketplace/gfg/ProductCard'
  import ProductCardIntegracommerce from '@/components/marketplace/integracommerce/ProductCard'
  import ProductCardLeroy from '@/components/marketplace/leroy/ProductCard'
  import ProductCardMadeira from '@/components/marketplace/madeira/ProductCard'
  import ProductCardNetshoes from '@/components/marketplace/netshoes/ProductCard'
  import ProductCardShopee from '@/components/marketplace/shopee/ProductCard'
  import ProductCardSkyhub from '@/components/marketplace/skyhub/ProductCard'
  import ProductCardWalmart from '@/components/marketplace/walmart/ProductCard'
  import ProductCardWebcontinental from '@/components/marketplace/webcontinental/ProductCard'
  import ProductCardZoom from '@/components/marketplace/zoom/ProductCard'
  import ProductCardCentauro from '@/components/marketplace/centauro/ProductCard'
  import ProductCardAmazon from '@/components/marketplace/amazon/ProductCard'
  import ProductCardRicardoEletro from '@/components/marketplace/ricardoEletro/ProductCard'
  import ProductCardRenner from '@/components/marketplace/renner/ProductCard'
  import ProductCardConectaLa from '@/components/marketplace/conectaLa/ProductCard'
  import ProductCardPolishop from '@/components/marketplace/polishop/ProductCard'
  import ProductCardSicoob from '@/components/marketplace/sicoob/ProductCard'
  import ProductCardPrivalia from '@/components/marketplace/privalia/ProductCard'
  import ProductCardDecathlon from '@/components/marketplace/decathlon/ProductCard'
  import ProductCardKeepRunning from '@/components/marketplace/keepRunning/ProductCard'
  import ProductCardRamarim from '@/components/marketplace/ramarim/ProductCard'
  import ProductCardComfortflex from '@/components/marketplace/comfortflex/ProductCard'
  import ProductCardSicredi from '@/components/marketplace/sicredi/ProductCard'
  import ProductCardMaisCorreios from '@/components/marketplace/maisCorreios/ProductCard'
  import ProductCardTikTokShop from '@/components/marketplace/tiktokshop/ProductCard'
  import ProductCardShein from '@/components/marketplace/shein/ProductCard'
  import ProductCardMagalu from '@/components/marketplace/magalu/ProductCard'

  export default {
    data: () => ({
      loading: false,
      productStatuses: [],
      productPriceStatuses: [],
      productStockStatuses: [],
      productImageStatuses: [],
      productCodes: [],
      productPriceTypes: [],
      productSaleAvailabilities: [],
      options: {
        code: '',
        title: '',
        brand: '',
        ean: '',
        status: null,
        priceStatus: null,
        stockStatus: null,
        imageStatus: null,
        priceType: null,
        saleAvailability: null,
        productId: null,
        account: null
      },
      sortFields: [
        'createdAt',
        'title',
        'brand'
      ],
      brands: [],
      productAccounts: [],
      route: null
    }),
    props: {
      customFilters: {
        type: Object,
        required: false
      },
      moduleIdentifier: {
        type: String,
        required: true
      }
    },
    created () {
      merge(this.options, this.productsMarketplaceLastFetchOptions)

      this.productCodes = this.productsMarketplaceTags['productCodes'] ? this.productsMarketplaceTags['productCodes'] : []
    },
    async updated () {
      const route = this.$router.history.current.path

      if (this.route === route) {
        return
      }

      this.clear()
      this.clearProductsMarketplace()

      this.route = route

      api.getBrands('marketplace', this.moduleIdentifier)
        .then(brands => { this.brands = brands })
        .catch(() => { this.brands = [] })

      api.getProductStatuses('marketplace', this.moduleIdentifier)
        .then(productStatuses => { this.productStatuses = productStatuses })
        .catch(() => { this.productStatuses = [] })

      api.getProductPriceStatuses('marketplace', this.moduleIdentifier)
        .then(productPriceStatuses => { this.productPriceStatuses = productPriceStatuses })
        .catch(() => { this.productPriceStatuses = [] })

      api.getProductStockStatuses('marketplace', this.moduleIdentifier)
        .then(productStockStatuses => { this.productStockStatuses = productStockStatuses })
        .catch(() => { this.productStockStatuses = [] })

      api.getProductImageStatuses('marketplace', this.moduleIdentifier)
        .then(productImageStatuses => { this.productImageStatuses = productImageStatuses })
        .catch(() => { this.productImageStatuses = [] })

      api.getProductPriceTypes('marketplace', this.moduleIdentifier)
        .then(productPriceTypes => { this.productPriceTypes = productPriceTypes })
        .catch(() => { this.productPriceTypes = [] })

      api.getProductSaleAvailabilities('marketplace', this.moduleIdentifier)
        .then(productSaleAvailabilities => { this.productSaleAvailabilities = productSaleAvailabilities })
        .catch(() => { this.productSaleAvailabilities = [] })

      if (this.moduleIdentifier === 'shopee') {
        api.shopee.getAccounts({})
          .then(accounts => { this.productAccounts = accounts.items })
          .catch(() => { this.productAccounts = [] })
      }

      if (this.moduleIdentifier === 'tikTokShop') {
        api.tikTokShop.getAccounts({})
          .then(accounts => { this.productAccounts = accounts.items })
          .catch(() => { this.productAccounts = [] })
      }

      if (this.moduleIdentifier === 'shein') {
        api.shein.getAccounts({})
          .then(accounts => { this.productAccounts = accounts.items })
          .catch(() => { this.productAccounts = [] })
      }

      merge(this.options, this.customFilters)

      this.onChange(this.options)
    },
    methods: {
      ...mapActions('productsMarketplace', [
        'fetch',
        'clearProductsMarketplace',
        'fillTags',
        'addTag'
      ]),
      ...mapActions('itemsSelected', [
        'clear'
      ]),
      async onChange (options) {
        if (this.loading) {
          return false
        }

        this.loading = true

        merge(options, this.customFilters)
        merge(this.options, options)

        const codes = []

        if (this.options.code !== '') {
          codes.push(this.options.code)
        }

        for (let i in this.productCodes) {
          let code = this.productCodes[i]
          if (code.hasOwnProperty('text')) {
            code = code.text
          }

          codes.push(code)
        }

        this.options.code = codes.join(',')

        this.clearProductsMarketplace()

        this.fillTags({
          productCodes: codes
        })

        this.fetch({
          type: 'marketplace',
          identifier: this.moduleIdentifier,
          options: this.options
        })
          .then(() => {})
          .catch(() => {})
          .then(() => {
            this.loading = false
            this.options.code = ''
          })
      },
      clearFilters () {
        this.options.code = ''
        this.productCodes = []
      }
    },
    computed: {
      ...mapFields({
        productsMarketplaceTotal: 'productsMarketplace.total',
        productsMarketplaceItems: 'productsMarketplace.items',
        productsMarketplaceLastFetchOptions: 'productsMarketplace.lastFetchOptions',
        productsMarketplaceTags: 'productsMarketplace.tags'
      }),
      ...mapGetters('module', [
        'getDefinitionModuleByIdentifierAndType'
      ]),
      module () {
        return this.getDefinitionModuleByIdentifierAndType('marketplace', this.moduleIdentifier)
      },
      productCardComponent () {
        if (!this.moduleIdentifier) {
          return null
        }

        return `ProductCard${upperFirst(this.moduleIdentifier)}`
      }
    },
    components: {
      FormGroup,
      List,
      Multiselect,
      Panel,
      VueTagsInput,
      ProductCardCarrefour,
      ProductCardCnova,
      ProductCardColombo,
      ProductCardGfg,
      ProductCardIntegracommerce,
      ProductCardLeroy,
      ProductCardMadeira,
      ProductCardNetshoes,
      ProductCardShopee,
      ProductCardSkyhub,
      ProductCardWalmart,
      ProductCardWebcontinental,
      ProductCardZoom,
      ProductCardCentauro,
      ProductCardAmazon,
      ProductCardRicardoEletro,
      ProductCardRenner,
      ProductCardConectaLa,
      ProductCardPolishop,
      ProductCardSicoob,
      ProductCardPrivalia,
      ProductCardDecathlon,
      ProductCardKeepRunning,
      ProductCardRamarim,
      ProductCardComfortflex,
      ProductCardSicredi,
      ProductCardTikTokShop,
      ProductCardShein,
      ProductCardMagalu,
      ProductCardMaisCorreios
    }
  }
</script>

<style scoped lang="sass">
  .count-selected
    margin-top: 4px

  .logo
    max-height: 30px
    margin-right: 20px

    .title
      margin-top: 16px
      margin-left: 20px

    .paginator
      float: right
</style>



// WEBPACK FOOTER //
// Shared.vue?c8dccee4